import { SystemStyleObject } from '@chakra-ui/react';
import { CounterBadgeSize } from './counter-badge';
import {
  getTypographyToken,
  ColorMode,
  getBoxSizingStyles,
} from '@allergan-data-labs/alle-elements-core';

interface CounterBadgeStyleProps {
  colorMode?: ColorMode;
  count?: number;
  size?: CounterBadgeSize;
}

export const getCounterBadgeStyles = ({
  colorMode = 'light',
  size = 'lg',
  count = 0,
}: CounterBadgeStyleProps): SystemStyleObject => {
  const isLargeSize = size === 'lg';

  const dimensions = isLargeSize
    ? { width: count <= 9 ? 18 : count <= 99 ? 21 : 26, height: 18 }
    : { width: 10, height: 10 };

  return {
    ...getBoxSizingStyles(),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    w: dimensions.width,
    h: dimensions.height,
    color: `${colorMode}.Container/Neutral/Static/White`,
    bg: `${colorMode}.Container/Brand/Medium 3`,
    borderRadius: 'Circle',
    ...getTypographyToken('Caption/Small/Medium'),
  };
};
